import axios from 'axios';


const url = '/api/configuration/sprint';

export const getList = ({ projectId }) => axios.get(url, { params: { projectId } })
    .then(response => response.data);

export const get = ({ id }) => axios.get(`${url}/${id}`)
    .then(response => response.data);

export const getTemplate = ({ projectId, sprintId, teamId }) => axios.get(`${url}/template`, { params: { projectId, sprintId, teamId } })
    .then(response => response.data);

export const getUsers = ({ teamId, startDate, endDate, sprintId }) => axios.get(`${url}/users`, { params: { teamId, startDate, endDate, sprintId } })
    .then(response => response.data);

export const upsert = ({
    sprintId,
    projectId,
    prevId,
    teamId,
    name,
    startDate,
    endDate,
    capacity,
    costOfEstimationUnit,
    costOfEstUnitInherit,
    users,
    isDeleted,
      }) => axios.post(url,
        {
            sprintId,
            projectId,
            prevId,
            teamId,
            name,
            startDate,
            endDate,
            capacity,
            costOfEstimationUnit,
            costOfEstUnitInherit,
            users,
            isDeleted,
        })
        .then(response => response.data);

export const complete = ({ sprintId }) => axios.post(`${url}/${sprintId}/complete`)
    .then(response => response.data);

export const activate = ({ sprintId }) => axios.post(`${url}/${sprintId}/activate`)
    .then(response => response.data);



// WEBPACK FOOTER //
// ../utils/api/configuration/sprint.js